import {
  FETCH_CHEMISTINVOICEDETAILS_SUCCESS_ACTION,
  FETCH_CHEMISTINVOICESEARCH_SUCCESS_ACTION,
  FILTER_BY_CHEMISTINVOICE_STATUS_SUCCESS_ACTION
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_CHEMISTINVOICEDETAILS_SUCCESS_ACTION:
      return {
        ...state,
        chemistInvoiceDtlsList: action.payload.rows,
        chemistInvoiceDtlsCount: action.payload.count
      };
    case FETCH_CHEMISTINVOICESEARCH_SUCCESS_ACTION:
      return {
        ...state,
        chemistInvoiceSearchList: action.payload.rows,
        chemistInvoiceSearchCount: action.payload.count
      };
    case FILTER_BY_CHEMISTINVOICE_STATUS_SUCCESS_ACTION:
      return {
        ...state,
        chemistInvoiceFilterList: action.payload.rows,
        chemistInvoiceFilterCount: action.payload.count
      };

    default:
      return {
        ...state
      };
  }
}
